import {
  ActivityIndicator,
  Image,
  Modal,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useState } from "react";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../utility/AppColors";
import { AppFontStyle } from "../styles/AppFontStyle";
import { AppImages } from "../utility/AppImages";
import Separator from "./Separator";
import ImageComponent from "./ImageComponent";
import CoinView from "./CoinView";

export default function AllSetPopup(props) {
  const { showModal = false, setShowModal, onClose } = props;
  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const onCloseClick = () => {
    setShowModal(false);
    if (onClose) onClose();
  };

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <TouchableOpacity
        style={styles.modalOverlay}
        activeOpacity={1}
        onPress={onCloseClick}
      >
        <View style={styles.container}>
          <TouchableOpacity activeOpacity={1} style={styles.mainView}>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Text
                style={[
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.MEDIUM_ANYBODY_18
                    : AppFontStyle.MEDIUM_ANYBODY_24,
                  {},
                ]}
              >
                All set!
              </Text>
              <TouchableOpacity
                onPress={onCloseClick}
                activeOpacity={0.5}
                style={{
                  padding: 7,
                  backgroundColor: AppColors.gray_212222,
                  borderWidth: 1,
                  borderColor: AppColors.grayColor_393939,
                  borderRadius: 6,
                }}
              >
                <Image
                  source={AppImages.icCloseWhiteSvg}
                  style={{
                    height: 16,
                    width: 16,
                    resizeMode: "contain",
                  }}
                />
              </TouchableOpacity>
            </View>
            <Separator
              color={AppColors.gray_838383}
              height={1}
              marginTop={8}
              marginBottom={22}
              marginHorizontal={0}
            />
            <View style={{ alignItems: "center" }}>
              <View
                style={{
                  borderRadius: 12,
                  borderColor: AppColors.white_D2D2D2,
                  borderWidth: 1,
                  height: 90,
                  justifyContent: "flex-end",
                }}
              >
                <ImageComponent
                  url="https://squadify-avatar.s3.eu-west-2.amazonaws.com/panda-head.svg"
                  style={[
                    {
                      resizeMode: "contain",
                      width: 100,
                      height: 75,
                    },
                  ]}
                />
              </View>
            </View>
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.SEMIBOLD_ANYBODY_28
                  : AppFontStyle.SEMIBOLD_ANYBODY_38,
                {
                  marginVertical:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? 12
                      : 22,
                  textAlign: "center",
                },
              ]}
            >
              Welcome Jacob
            </Text>
            <Text
              style={[
                AppFontStyle.MEDIUM_ANYBODY_18,
                {
                  textAlign: "center",
                  lineHeight: 25,
                },
              ]}
            >
              Congratulations on completing the setup!
            </Text>
            <Text
              style={[
                AppFontStyle.MEDIUM_ANYBODY_18,
                {
                  textAlign: "center",
                  lineHeight: 25,
                },
              ]}
            >
              You’re all set to dive into the action. To help you get started,
              Click the Start tutorial button.
            </Text>
            <View style={{ alignItems: "center", marginTop: 22 }}>
              <TouchableOpacity
                style={{
                  paddingVertical: 8,
                  paddingHorizontal: 6,
                  borderWidth: 1,
                  borderColor: AppColors.white,
                  borderRadius: 4,
                }}
              >
                <Text style={[AppFontStyle.SEMIBOLD_ANYBODY_16, {}]}>
                  Start Tutorial
                </Text>
              </TouchableOpacity>
            </View>
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    modalOverlay: {
      flex: 1,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      justifyContent: "center",
      alignItems: "center",
    },
    container: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      width: "50%",
      backgroundColor: AppColors.purple_453B50,
      padding: 24,
      margin: 30,
      alignSelf: "center",
      borderRadius: 22,
      borderWidth: 1,
      borderColor: AppColors.gray_A6A3AA,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {
      mainView: {
        width: "95%",
        padding: 12,
      },
    },
    [DEVICE_SIZES.XS]: {
      mainView: {
        width: "95%",
        padding: 12,
      },
    },
  }
);
